






























































































































import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
import moment from "moment-timezone";
import ReportDateFilter from "./ReportDateFilter.vue";

interface SalesReport {
  report_name: string;
  value: number;
  count?: number;
}

const { mapActions: reportsActions, mapGetters: reportsGetters } =
  createNamespacedHelpers("reports");

const tz = localStorage.getItem("tz") ?? "Africa/Nairobi";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default Vue.extend<any, any, any, any>({
  name: "SalesReportList",
  components: {
    ReportDateFilter,
  },

  props: {
    cardView: {
      default: false,
    },
  },
  data: () => ({
    headers: [
      { text: "Type", value: "report_name", sortable: false },
      { text: "Sales", value: "value", sortable: false },
      { text: "actions", value: "actions", sortable: false },
    ],
    startDate: null,
    endDate: null,
    applyDateFilter: true,
    filterStart: null,
    filterEnd: null,
    params: {},
  }),
  computed: {
    ...reportsGetters(["salesReports", "loading", "error"]),
    reports(): SalesReport[] {
      return this.salesReports || [];
    },
  },
  methods: {
    ...reportsActions(["fetchSalesReports"]),
    getParams() {
      const queryString = window.location.search;
      const params = new URLSearchParams(queryString);
      this.params = {
        method: params.get("method"),
        startDate: params.get("startDate"),
        endDate: params.get("endDate"),
        type: params.get("type"),
      };
    },
    onRangeChange(filters) {
      this.filterStart = filters.start;
      this.filterEnd = filters.end;

      if (this.applyDateFilter) {
        this.startDate = filters.start;
        this.endDate = filters.end;
      }
    },
    async fetchSalesReportsData() {
      try {
        await this.fetchSalesReports({
          startDate: this.startDate,
          endDate: this.endDate,
        });
      } catch (error) {
        console.error("Error fetching sales reports:", error);
      }
    },
    formatDate(date: string) {
      if (!date) return null;

      return moment(date).tz(tz).format("DD/MM/YYYY");
    },
    clear() {
      this.startDate = null;
      this.endDate = null;
    },
    navigate(item: SalesReport) {
      const query: Record<string, string> = {
        tab: "orders",
        type: item.report_name.toLowerCase().slice(0, -1),
      };
      if (this.startDate) {
        const date = new Date(this.startDate);
        date.setHours(0, 0, 0, 0);
        query.startDate = date.toISOString();
      }
      if (this.endDate) {
        const date = new Date(this.endDate);
        date.setHours(23, 59, 59, 59);
        query.endDate = date.toISOString();
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this as any).$router.push({
        path: "/reports/report-detail",
        query,
      });
    },
    getReportIcon(reportName: string): string {
      const iconMap: Record<string, string> = {
        "All Sales": "mdi-cash-multiple",
        "Cash Sales": "mdi-cash",
        "Card Sales": "mdi-credit-card",
        "Mobile Sales": "mdi-cellphone",
        "Online Sales": "mdi-web",
        "Service Sales": "mdi-account-group",
        "Product Sales": "mdi-package-variant",
      };
      return iconMap[reportName] || "mdi-chart-bar";
    },
    getReportIconColor(reportName: string): string {
      const colorMap: Record<string, string> = {
        "All Sales": "primary",
        "Cash Sales": "green",
        "Card Sales": "blue",
        "Mobile Sales": "orange",
        "Online Sales": "purple",
        "Service Sales": "teal",
        "Product Sales": "indigo",
      };
      return colorMap[reportName] || "grey";
    },
    getValueChipColor(value: number): string {
      if (value >= 100000) return "green";
      if (value >= 50000) return "blue";
      if (value >= 10000) return "orange";
      return "grey";
    },
  },
  watch: {
    applyDateFilter(x) {
      if (!x) {
        this.startDate = null;
        this.endDate = null;
      } else {
        this.startDate = this.filterStart;
        this.endDate = this.filterEnd;
      }
    },
    startDate() {
      this.fetchSalesReportsData();
    },
    endDate() {
      this.fetchSalesReportsData();
    },
  },
  mounted() {
    console.log("mounted");
    this.getParams();
    this.fetchSalesReportsData();
  },
});
